import { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import styled from 'styled-components'

import { StoresContext } from '../../../provider/StoreProvider'

import { Wrap } from '../../../components/container/Wrap'
import { Content } from '../../../components/container/Content'
import { Header } from '../../../components/header'
import { PagingContent } from '../../../components/pagingList'
import { DivideLine } from '../../../components/divide'
import { NotificationList, NotificationItem } from '../../notification/components/List'

export const NoticeList = observer(() => {
  const { commonStore, myStore } = useContext(StoresContext)
  const pagingStore = myStore.noticePagingStore

  useEffect(() => {
    console.log('enter')
    commonStore.setShowTab(false)
    pagingStore.load({ data: { size: 100 } }, true)
  }, [])

  return (
    <Wrap>
      <Header type="SUB" title="공지사항" />
      <StyledContent>
        <PagingContent emptyText="조회 가능한 공지사항이 없습니다." pagingStore={pagingStore}>
          <NotificationList>
            {pagingStore.list.map(({ id, title, createdDate }) => (
              <Link key={id} to={`/notice/${id}`}>
                <NotificationItem>
                  <NotificationItem.Title>{title ?? ''}</NotificationItem.Title>
                  <NotificationItem.Date>{createdDate ?? ''}</NotificationItem.Date>
                </NotificationItem>
                <DivideLine />
              </Link>
            ))}
          </NotificationList>
        </PagingContent>
      </StyledContent>
    </Wrap>
  )
})

const StyledContent = styled(Content)`
  padding-top: 8px;
`
